import script from "./BillingApplePriceComparison16218.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingApplePriceComparison16218.vue?vue&type=script&setup=true&lang=ts"

import "./BillingApplePriceComparison16218.vue?vue&type=style&index=0&id=f237419e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f237419e"]])

export default __exports__